/**
 * deepseek -- 输入
 */
import React, { useEffect, useRef } from 'react'
import { Button, Input, Modal } from 'antd'
import styles from './index.module.css'
import {
  Plus,
  IconShenndusikao,
  IconLianwang,
  Gallery,
  IconPaperclip,
  IconFasong,
  IconTingzhi,
  IconXiayihua,
} from 'wujieai-react-icon'
import classNames from 'classnames'
import { useState } from 'react'
import { useAuth } from '~/hooks/useAuth'
import { useRouter } from 'next/router'
import {
  useIsMessageListReachBottom,
  useScrollMessageListToBottom,
} from '~/components/pages/deepseek/hooks'
import { useAtom, useAtomValue } from 'jotai'
import {
  conversationIdAtom,
  deepseekMethodAtom,
} from '~/components/pages/deepseek/atom'
import { useValidateVip } from '~/hooks/useValidateVip'
import type { InputRef } from 'antd'
interface IProps {
  sendMessage: (params: any) => void
  isTyping: boolean
  isThinking: boolean
  stopMessage: () => void
  className?: string
  style?: React.CSSProperties
}
const methods = [
  {
    icon: <IconShenndusikao size={14} className="mr-1" />,
    label: '深度思考',
    key: 'thinking',
  },
  {
    icon: <IconLianwang size={14} className="mr-1" />,
    label: '联网搜索',
    key: 'search',
  },
]
const DsInput: React.FC<IProps> = ({
  sendMessage,
  stopMessage,
  isTyping,
  isThinking,
  className,
  style,
}) => {
  const [selectedMethods, setSelectedMethods] = useAtom(deepseekMethodAtom)
  const [showUpload, setShowUpload] = useState(false)
  const [fileList, setFileList] = useState<any[]>([])
  const [prompt, setPrompt] = useState('')
  const { reachBottom: isMessageListReachBottom } =
    useIsMessageListReachBottom()
  const scrollMessageListToBottom = useScrollMessageListToBottom()
  const conversationId = useAtomValue(conversationIdAtom)
  const inputRef = useRef<InputRef>(null)

  const { isHighUser } = useAuth()
  const { vipModal } = useValidateVip()

  const seeking = isTyping || isThinking

  /** 发送 */
  const onSend = () => {
    if (!prompt) {
      return
    }
    if (!isHighUser) {
      vipModal('此功能仅限VIP会员用户使用')
      return
    }
    sendMessage({
      input: prompt,
    })

    // 清空输入框
    setPrompt('')
  }

  useEffect(() => {
    setPrompt('')
    inputRef?.current!.focus({
      cursor: 'end',
    })
  }, [conversationId])

  return (
    <div className={classNames(className, styles.footerWrap)} style={style}>
      {!isMessageListReachBottom && (
        <div
          onClick={() => scrollMessageListToBottom()}
          className="absolute -top-[50px] right-4 z-10 w-8 h-8 rounded-full bg-neutral-300 flex items-center justify-center p-2 cursor-pointer"
        >
          <IconXiayihua className="text-neutral-500" />
        </div>
      )}

      <Input.TextArea
        ref={inputRef}
        placeholder="请尽情向我提问~"
        className={classNames(styles.input)}
        value={prompt}
        onChange={e => {
          setPrompt(e.target.value)
        }}
        onPressEnter={e => {
          if (!e.shiftKey && !seeking) {
            e.preventDefault()
            onSend()
          }
        }}
        rows={1}
        maxLength={20000}
        autoSize={{ maxRows: 3 }}
      />
      <div className="flex justify-between items-center pt-6">
        <div className="flex text-xs font-bold text-neutral-400">
          {methods.map(it => (
            <div
              className={classNames(
                'flex items-center bg-neutral-300 rounded-full p-2 leading-4 mr-3 cursor-pointer',
                selectedMethods.some(key => key === it.key) &&
                  'bg-[#34226A] text-[#7851EC]'
              )}
              key={it.key}
              onClick={() => {
                if (selectedMethods.some(key => key === it.key)) {
                  setSelectedMethods(
                    selectedMethods.filter(key => key !== it.key)
                  )
                } else {
                  // @ts-ignore
                  setSelectedMethods([...selectedMethods, it.key])
                }
              }}
            >
              {it.icon}
              <span>{it.label}</span>
            </div>
          ))}
        </div>
        <div>
          {seeking ? (
            <Button
              type="primary"
              shape="circle"
              className="!h-8 !w-8 !p-0 !flex justify-center items-center !border-0"
              onClick={stopMessage}
            >
              <IconTingzhi size={24} />
            </Button>
          ) : (
            <Button
              type="primary"
              shape="circle"
              className={classNames(
                '!h-8 !w-8 !p-0 !flex items-center justify-center  !border-0',
                !prompt && '!bg-neutral-300 !text-neutral-400'
              )}
              onClick={onSend}
            >
              <IconFasong size={24} className="block" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
export default DsInput
